export default "__VITE_ASSET__5f2c45cd__"